/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout";
import Login from "./Login";
import ForgotPassword from "./ForgotPassword";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import Verification from "./Verification";
import InstructionsSent from "./InstructionsSent";
import SetNewPassword from "./SetNewPassword";
import HomePage from "./HomePage";
import Header from "./Header";
import Footer from "./Footer";
import AboutUs from "./AboutUs";
import HowItWorks from "./HowItWorks";
import ContactUs from "./ContactUs";
import Register from "./Register";
import RegisterVerification from "./RegisterVerification";
import BasicInformation from "./BasicInformation";
import logout from "./Logout";
import GoldBarInfo from './GoldBarInfo'

export function AuthPage() {
  return (
    <>
      <Header />
      <Switch>
        <ContentRoute exact path="/" component={HomePage} />
        <ContentRoute path="/about-us" component={AboutUs} />
        <ContentRoute path="/gold-bar-info/:serialNo" component={GoldBarInfo} />
        <ContentRoute path="/how-it-works" component={HowItWorks} />
        <ContentRoute path="/contact-us" component={ContactUs} />
        <ContentRoute path="/login" component={Login} />
        <ContentRoute path="/register" component={Register} />
        <ContentRoute path="/verification" component={Verification} />
        <ContentRoute path="/instructions-sent" component={InstructionsSent} />
        <ContentRoute
          path="/set-new-password/:resetToken"
          component={SetNewPassword}
        />
        <ContentRoute
          path="/register-verification"
          component={RegisterVerification}
        />
        <ContentRoute path="/basic-information" component={BasicInformation} />
        <ContentRoute path="/logout" component={logout} />
        <ContentRoute path="/forgot-password" component={ForgotPassword} />

        <Redirect from="/" exact={true} to="/" />
        <Redirect to="/" />
      </Switch>
      <Footer />
    </>
  );
}
